export enum PLPVariant {
  DEFAULT = 'default',
  PRIVEE = 'privee',
  CAMPAIGN = 'campaign'
}
